import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const OpcionalesDialog = ({ data, onClose, onConfirm }) => {
  const [seleccion, setSeleccion] = useState({});

  useEffect(() => {
    if (!data) return;
    setSeleccion(Object.fromEntries(data.items.map((it) => [it.repuesto_id, true])));
  }, [data]);

  const toggle = (id) => setSeleccion((s) => ({ ...s, [id]: !s[id] }));
  const elegidos = data?.items.filter((it) => seleccion[it.repuesto_id]) || [];

  return (
    <Dialog open={!!data} onOpenChange={onClose}>
      <DialogContent className="bg-white max-w-lg">
        <DialogHeader>
          <DialogTitle>Repuestos opcionales</DialogTitle>
          <DialogDescription className="text-xs">
            {data?.titulo ? `"${data.titulo}" incluye` : "La plantilla incluye"} repuestos recomendados pero no obligatorios. Elige cuáles agregar a la cotización.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1 max-h-72 overflow-y-auto">
          {data?.items.map((it) => (
            <label key={it.repuesto_id} data-testid={`opcional-check-${it.codigo_parte}`}
              className="flex items-center gap-2 border border-border rounded-sm px-3 py-2 text-sm cursor-pointer hover:bg-secondary">
              <Checkbox checked={!!seleccion[it.repuesto_id]} onCheckedChange={() => toggle(it.repuesto_id)} />
              <span className="font-mono font-semibold text-xs">{it.codigo_parte}</span>
              <span className="flex-1 truncate">{it.nombre}</span>
              <span className="text-xs text-muted-foreground">x{it.cantidad}</span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button data-testid="omitir-opcionales-btn" variant="outline" onClick={onClose}>No agregar</Button>
          <Button data-testid="agregar-opcionales-btn" onClick={() => onConfirm(elegidos)} disabled={elegidos.length === 0}>
            Agregar seleccionados ({elegidos.length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
